<template>
<div>
    <v-app-bar app color="primary" dark flat>
        <div class="d-flex align-center">
            <v-img alt="UNDB" class="shrink mr-2" contain
                src="@/assets/logo_saude.png"
                transition="scale-transition" width="50" />

            <h2 v-if="!$vuetify.breakpoint.xsOnly"> Labs Saúde</h2>
        </div>

        <v-spacer></v-spacer>
        <div v-if="computedUser && computedUser.username">

            <span>{{computedUser.first_name}}</span>
            <v-btn icon @click="logout" v-if="computedUser && computedUser.username" text>
                <v-icon>mdi-exit-run</v-icon>
            </v-btn>
        </div>
    
    </v-app-bar>

</div>
</template>

<script>
//import logoundb from '@/assets/logo_saude.png'
export default {
    name:'navbar',
    data(){
        return{
            sidebar:true
        }
    },
    methods:{
        logout(){
            this.$store.loginStore.commit('encerrar')
            this.$router.history.push({name:'login'})
        }
    },
    computed:{
        computedUser(){
            return this.$store.loginStore.getters.getUserAthenticated
        }
    }

}
</script>